import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Rating from "@mui/material/Rating";
import Box from "@mui/material/Box";
import authQueries from "./queries/authQueries";
import "./App.css";
import "typeface-public-sans";

const ReviewForm = () => {
  const param = window.location.href;
  const newUrl = new URL(param);
  const propertyId = newUrl.searchParams.get('propertyId');
  const guestName = newUrl.searchParams.get('guestName');
  const source = newUrl.searchParams.get('source');
  const bookingId = newUrl.searchParams.get('bookingId');
  const [rating, setRating] = useState(0);
  const [propertyName, setPropertyName] = useState("");
  const navigate = useNavigate();

  // Configuration object for hardcoded properties
  const propertyConfig = {
    "USREPA241201": {
      name: "Spice House Authentic Indian Bistro",
      publicReviewUrl: "https://g.page/r/CXCqdQQnAM-9EBM/review"
    },
    "USPHTX241201": {
      name: "Medfirst Pharmacy",
      publicReviewUrl: "https://g.page/r/CQoRVxoRbU4BEBI/review"
    },
    "ORUSCA241101": {
      name: "Hotel HWood",
      publicReviewUrl: "https://g.page/r/CYijCnjJ2ksdEBM/review"
    },
    "ORUSND250101": {
      name: "Travelodge by Wyndham Fargo West Acres",
      publicReviewUrl: "https://g.page/r/CQYHtMlz6859EBM/review"
    },
    "ORES0525001": {
      name: "Kaak Al Manara Restaurant & Bakery",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJ8w2OCD1DXz4RgGjbZXgaQZY"
    },
    "ORES0525002": {
      name: "Kaak Al Manara Restaurant & Bakery",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJNe__dh9rXz4RMZLwjD3wKzc"
    },
    "ORES0525003": {
      name: "Manaret Beirut Restaurant and Cafe",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJ-T2Z0UxvXz4RbXdgXsC7UEc"
    },
    "ORES0525004": {
      name: "Bombay Spice II",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJJ51Yek-2w4kRmuVxKJlFk3k"
    },
    "ORES0525005": {
      name: "La Quinta Inn & Suites by Wyndham San Antonio Riverwalk",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJ90YMOAD2XIYRdqMe5_2CEZk"
    },
    "ORES0525006": {
      name: "Courtyard by Marriott Portland East",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJ2TX04FGjlVQR8tG1jvr1IL0"
    },
    "ORES0525007": {
      name: "Hampton Inn Ft. Lauderdale-Cypress Creek",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJDyfAT0kC2YgRCc7UdMULNxE"
    },
    "ORES0525008": {
      name: "Four Points by Sheraton Destin-Fort Walton Beach",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJqee6EUw_kYgRVtm5AGrMRNk"
    },
    "ORES0525009": {
      name: "Courtyard by Marriott Atlantic City Beach Block",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJAXMnzT7uwIkRMr2XWBIbJkw"
    },
    "ORNJ250606": {
      name: "SpringHill Suites Woodbridge",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJly68Fse1w4kRdw3xSmIl5uQ"
    },
    "ORNJ250604": {
      name: "Courtyard North Brunswick",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJ76eNk4bDw4kRtb8TaLP9--Q"
    },
    "ORNJ250605": {
      name: "Fairfield Inn & Suites Parsippany",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJ02RvpTkIw4kR1e0bfzFpQGQ"
    },
    "ORIL250601": {
      name: "Holiday Inn Express Chicago - Magnificent Mile by IHG",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJafNNF60sDogRI9oGHNcZAUI"
    },
    "ORPA250603": {
      name: "Hampton Inn & Suites Newtown",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJa0666TpUwYkRn_K-QeV5yv4"
    },
    "ORLA250607": {
      name: "Clarion Hotel New Orleans - Airport & Conference Center",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=posting_reviews_is_disabled"
    },
    "ORDE250608": {
      name: "DoubleTree by Hilton Hotel Downtown Wilmington - Legal District",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJCaHMnkH9xokR7DRuPOYv2N8"
    },
    "ORTX250609": {
      name: "Hilton Garden Inn Houston NW/Willowbrook",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJsS9Bte_NQIYRZNQnKTLmQ4M"
    },
    "ORUSTX240901": {
      name: "Courtyard Fort Worth I-30 West Near NAS JRB",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJfwwY0zFzToYRPq-shHiIx_o"
    },
    "USREPA250201": {
      name: "Panorama",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJWYx1XY_IxokRdeJwgE_Gc54"
    },
    "ORLA250602": {
      name: "City Express by Marriott New Orleans I-10",
      publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJDdJH_ccDnogR4DH06mxnr7k"
    },
    "ORES250801": {
          name: "DILLI DILLI",
          publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJy5GbOlRYwokR0Nb62lBJzm8"
    },
    "ORES250802": {
          name: "Bhatti Indian Grill",
          publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJpaNqfadZwokRU9Jf1Ld4Rz0"
    },
    "ORKY250901": {
          name: "GLō Best Western Lexington",
          publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJdR_oOx5FQogRmHbH66bA25o"
    },
    "ORKY250902": {
          name: "Fairfield by Marriott Inn & Suites Lexington North",
          publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJfWKnlCpEQogRSwdHDukJ39A"
    },
    "ORIL251001": {
          name: "Residence Inn by Marriott Peoria",
          publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJ8Sca_opbCogRM_hre_06ngI"
    },
    "ORIL251002": {
          name: "Courtyard by Marriott Peoria",
          publicReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJdRTImIpbCogRploOWV08UvM"
    }
  };

  const setLocalStorageData = (propertyId, bookingId, guestName, source, publicReviewUrl) => {
    localStorage.setItem("publicReviewUrl", publicReviewUrl);
    localStorage.setItem("propertyId", propertyId);
    localStorage.setItem("bookingId", bookingId || "");
    localStorage.setItem("guestName", guestName || "");
    localStorage.setItem("source", source || "");
  };

  const apicallAndSetters = async () => {
    // Check if propertyId exists in our configuration
    const propertyData = propertyConfig[propertyId];
    
    if (propertyData) {
      setPropertyName(propertyData.name);
      setLocalStorageData(propertyId, bookingId, guestName, source, propertyData.publicReviewUrl);
      return;
    }

    // Fall back to API call for properties not in configuration
    try {
      const response = await getProperty.mutateAsync({
        propertyId: propertyId,
      });
      setPropertyName(response.info.propertyName);
      localStorage.setItem('propertyId', propertyId);
      localStorage.setItem('bookingId', ((bookingId===null ) ? "": bookingId));
      localStorage.setItem('guestName', ((guestName===null ) ? "": guestName));
      localStorage.setItem('source', ((source===null ) ? "": source));
    } catch (error) {
      console.log("Errors occurred during the API call");
    }
  };

  useEffect(() => {
    apicallAndSetters();
  }, []);

  const getProperty = authQueries.useGetProperty(propertyId, (response) => {
    // Skip callback if property is in our configuration (already handled)
    if (propertyConfig[propertyId]) {
      return;
    }

    if (response) {
      console.log("Response====" + response);
      const propertyName = response.info.propertyName;
      const publicReviewUrl = response.info.publicReviewUrl;
      localStorage.setItem("propertyName", propertyName);
      localStorage.setItem("publicReviewUrl", publicReviewUrl);
    } else {
      console.log("No data found");
    }
  });

  const generateRandomValue = (length) => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let randomString = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      randomString += characters[randomIndex];
    }
    return randomString;
  };

  const copyToClipboard = (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => {
        console.log("Text copied to clipboard");
      }).catch((error) => {
        console.error("Failed to copy text to clipboard:", error);
      });
    } else {
      console.warn("Clipboard API not available in this browser.");
    }
  };

  const ratingDbUpdate =  async () => {
    const response = await trackRating.mutateAsync({
      propertyId: propertyId,
      ratingScore: rating,
    });
    console.log("Response:" + response);
  };

  const trackRating = authQueries.useTrackRating( propertyId, (response) => {
    console.log("Response saved into DB:" + response);
  });

  const handleSubmit = () => {
    if (rating === 0) return;
    ratingDbUpdate();
    if (rating >= 4) {
      window.location.href = localStorage.getItem('publicReviewUrl');
    } else {
      navigate("/feedback-form", {
        state: { rating }
      });
    }
  };

  const reviewContentText = (propertyId) => {
    if (propertyId === "USPHTX241201") {
      return "Please rate your overall experience";
    }
    else if (propertyId === "ORES250801" || propertyId === "ORES250802" || propertyId === "USREPA241201" || propertyId === "ORES0525001" || propertyId === "ORES0525002" || propertyId === "ORES0525003" || propertyId === "ORES0525004" || propertyId === "USREPA250201") {
      return "Please rate your overall experience with our food and service";
    }
    else {
      return "Please rate your overall experience of the stay";
    }
  };


  return (
    <div style={{ position: "relative", height: "50vh" }}>
      <h1 className="header-name">{propertyName}</h1>
      <div className="reviews-content">
        <label className="reviews-content-label" htmlFor="rating" style={{ color: "#2F2F2F", fontSize: "16px" }}>
        {reviewContentText(propertyId)}
        </label>
        <div className="form-group">
          <Box
            component="fieldset"
            borderColor="transparent"
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Rating
              name="rating"
              value={rating}
              onChange={(event, newValue) => {
                setRating(newValue);
              }}
              size="large"
            />
          </Box>
        </div>
        
        <button onClick={handleSubmit}>Next</button>
      </div>
    </div>
  );
};

export default ReviewForm;
